import { render, staticRenderFns } from "./DetayButon.vue?vue&type=template&id=36a5c124&"
import script from "./DetayButon.vue?vue&type=script&lang=js&"
export * from "./DetayButon.vue?vue&type=script&lang=js&"
import style0 from "./DetayButon.vue?vue&type=style&index=0&id=36a5c124&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports